var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_mobile" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.mobile")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.mobile,
            expression: "contact.mobile"
          }
        ],
        staticClass: "form-control",
        class: {
          "is-invalid":
            _vm.contact.mobile && !_vm.isValidPhone(_vm.contact.mobile)
        },
        attrs: {
          id: _vm.uid + "_mobile",
          type: "tel",
          placeholder: _vm.phonePlaceholder
        },
        domProps: { value: _vm.contact.mobile },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "mobile", $event.target.value)
          }
        }
      }),
      _vm._v(" "),
      _vm.contact.mobile && !_vm.isValidPhone(_vm.contact.mobile)
        ? _c("small", { staticClass: "text-danger" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("common.contacts.invalidPhoneNumber")) +
                "\n    "
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_department" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.department")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.department,
            expression: "contact.department"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_department", type: "text" },
        domProps: { value: _vm.contact.department },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "department", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_position" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.position")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.position,
            expression: "contact.position"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_position", type: "text" },
        domProps: { value: _vm.contact.position },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "position", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_status" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.status")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.status,
            expression: "contact.status"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_status", type: "text" },
        domProps: { value: _vm.contact.status },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "status", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_region" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.region")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.region,
            expression: "contact.region"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_region", type: "text" },
        domProps: { value: _vm.contact.region },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "region", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_street" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.street")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.street,
            expression: "contact.street"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_street", type: "text" },
        domProps: { value: _vm.contact.street },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "street", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_postalcode" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.postalCode")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.postalCode,
            expression: "contact.postalCode"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_postalcode", type: "text" },
        domProps: { value: _vm.contact.postalCode },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "postalCode", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_city" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.city")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.city,
            expression: "contact.city"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_city", type: "text" },
        domProps: { value: _vm.contact.city },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "city", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_country" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.country")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.country,
            expression: "contact.country"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_country", type: "text" },
        domProps: { value: _vm.contact.country },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "country", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_comment" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.comment")))
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.comment,
            expression: "contact.comment"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_comment", rows: "3" },
        domProps: { value: _vm.contact.comment },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "comment", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_ident1" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.ident1")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.ident1,
            expression: "contact.ident1"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_ident1", type: "text" },
        domProps: { value: _vm.contact.ident1 },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "ident1", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_ident2" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.ident2")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.ident2,
            expression: "contact.ident2"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_ident2", type: "text" },
        domProps: { value: _vm.contact.ident2 },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "ident2", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: _vm.uid + "_roleaccess" } }, [
        _vm._v(_vm._s(_vm.$t("common.contacts.model.roleAccess")))
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contact.roleAccess,
            expression: "contact.roleAccess"
          }
        ],
        staticClass: "form-control",
        attrs: { id: _vm.uid + "_roleaccess", type: "text" },
        domProps: { value: _vm.contact.roleAccess },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.contact, "roleAccess", $event.target.value)
          }
        }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }